/* eslint-disable react-hooks/exhaustive-deps */
import {
  CloseCircleOutlined,
  DeleteOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { RoleHeadOffice } from "@src/routers/roles/roles.const";
import { Button, Col, Input, Modal, Row, Select, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import BreakLine from "../../component/Desktop/breakLine";
import GroupItem from "../../component/Desktop/groupItem";
import Loading from "../../component/Desktop/loading/loading";
import RowInput from "../../component/Desktop/rowInput";
import TitlePage from "../../component/Desktop/titlePage";
import FooterPage from "../../component/footer/footerPage";

import {
  COMMON_CONSTANT,
  KEY,
  lang,
  STYLE,
} from "../../constants/common.const";
import { handleCatchError, showMessage } from "../../constants/utils";

import kbn from "../../api/backend/kbn";
import { VideoApi } from "../../api/backend/video";
import SelectWithTagAll from "../../component/FormInput/SelectWithTagAll";
import classDdl from "../../models/control/dropdownlist";
import classPopup from "../../models/control/popup";
import classText from "../../models/control/text";
import rolesConst from "../../routers/roles/roles.const";
import { FullTextTag } from "./FullTextTag";
import { SearchMachineVideo } from "./searchMachineVideo";
const NORMAL_TEXT_LENGTH = 255;
const LONG_TEXT_LENGTH = 1000;
const CATEGORY_INSTRUCTION = 2;
const TagLikeSingleSelect = ({
  value = [],
  listOption = [],
  setSelected = () => {},
  callback=() => {},
}) => {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setOptions(listOption);
  }, [listOption]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const trimmed = inputValue.trim();
      if (!trimmed) return;

      const listKey = options.map((i) => i.key);
      const listValue = options.map((i) => i.value);

      const indexKey = listKey.findIndex((k) => k === trimmed);
      const indexValue = listValue.findIndex((v) => v === trimmed);

      // Nếu không tồn tại → thêm mới
      if (indexKey < 0 && indexValue < 0) {
        const key = new Date().getTime().toString();
        const newItem = { key, value: trimmed, isNew: true };
        setOptions((prev) => [...prev, newItem]);
        setSelected([newItem]);
      } else {
        const index = indexKey >= 0 ? indexKey : indexValue;
        const existing = options[index];
        setSelected([existing]);
      }

      setInputValue("");
      e.preventDefault();
    }
  };

  const handleChange = (val) => {
    if (!Array.isArray(val) || val.length < 1) {
      setSelected([]);
      return;
    }

    const currentKey = val[val.length - 1];
    const selectedItem = options.find((i) => i.key == currentKey);
    if (selectedItem) {
      setSelected([selectedItem]);
    }
    callback(selectedItem)
  };

  return (
    <Select
      tagRender={(props) => <FullTextTag {...props} />}
      optionFilterProp="children"
      showSearch
      dropdownClassName="custom-select-hover"
      showArrow
      mode="tags"
      style={{ width: "100%" }}
      value={value.map((i) => i.key)}
      onChange={handleChange}
      onInputKeyDown={handleKeyDown}
      onSearch={(val) => setInputValue(val.slice(0, NORMAL_TEXT_LENGTH))}
      searchValue={inputValue}
      tokenSeparators={[]}
    >
      {options.map((opt) => (
        <Select.Option key={opt.key} value={opt.key}>
          {opt.value}
        </Select.Option>
      ))}
    </Select>
  );
};

 const TagVideoSelect = ({ tags = [], setTags = () => {}, listAll = [],className }) => {
    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState([]);
    const [selectKey, setSelectKey] = useState(true);
    const selectRef = useRef();
  
    useEffect(() => {
      setOptions(listAll);
    }, [listAll]);
  
    const handleChange = (values) => {
      setInputValue("");
      setSelectKey(!selectKey);
      const unique = Array.from(new Set(values));
      setTags(unique);
    };
  
    const handleInputKeyDown = (e) => {
      if (e.key === "Enter" || e.key === " " || e.key === ",") {
        const trimmed = inputValue.trim();
        if (!trimmed) {
          e.preventDefault();
          return;
        }
  
        const isAlreadySelected = tags.includes(trimmed);
        const isInOptions = options.includes(trimmed);
  
        if (!isAlreadySelected) {
          const newTags = [...tags, trimmed];
          setTags(newTags);
        }
        if (!isInOptions) {
          setOptions((prev) => [...prev, trimmed]);
        }
  
        setInputValue("");
        setSelectKey(!selectKey);
        e.preventDefault();
        setTimeout(() => {
          selectRef.current.focus();
        }, 0);
      }
    };
    useEffect(() => {
      setInputValue(""); 
    }, [tags]);
    return (
      <Select
       tagRender={(props) => <FullTextTag {...props} />}
       dropdownClassName="custom-select-hover"
        showArrow
        showSearch
        ref={selectRef}
        mode="tags"
        value={tags}
        onChange={handleChange}
        onSearch={(val) => setInputValue(val.slice(0, 255))}
        onInputKeyDown={handleInputKeyDown}
        tokenSeparators={[]} 
        options={options.map((tag) => ({ value: tag, label: tag }))}
        className={className}
        searchValue={inputValue}
      />
    );
  };

//Declare global variables
const { TextArea } = Input;
let FLAG_CHANGE_DATA = false;
function AddVideo() {
  const VALUE_FULL = "99999";

  const { isYuni, roles, selectedFactory, factories } = useSelector(
    (state) => state.auth
  );
  const [listSelectMachine,setListSelectMachine] = useState([])
  const isAdmin = roles == rolesConst.HEAD_OFFICE_ADMIN;
  const isStaff = roles == rolesConst.OFFICE_USER;

  let { id } = useParams();
  const history = useHistory();

  let [initPage, setInitPage] = useState(true);
  let [showLoading, setShowLoading] = useState(false);
  const { headOfficeRole, displayName, selectedFactoryName } = useSelector(
    (state) => state.auth
  );

  const currentSelectOffice = {
    key: selectedFactory,
    value: selectedFactoryName,
  };
  const { Option } = Select;
  // Loading
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };

  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };
  const [isDirty, setIsDirty] = useState(false);

  // Group 1
  let [hdnChecklistID, sethdnChecklistID] = useState(new classText());
  let txtNameEl = useRef(null);

  let [txtTitle, settxtTitle] = useState(new classText()); //Required
  const [txtDescription, setTxtDescription] = useState(new classText());
  let [sender, setSender] = useState(new classText()); //Required

  const [videoUrl, setVideoUrl] = useState(new classText());
  const [listCate, setListCate] = useState(new classDdl());
  const [tags, setTags] = useState([]);
  const [listAllTag, setListAllTag] = useState([]);
  const [listAllCategory, setListAllCategory] = useState([]);
  const titleRef = useRef();
  const urlRef = useRef();
  const [selectedOffice, setSelectedOffice] = useState(
    !isAdmin ? [currentSelectOffice.key] : []
  );
  const [rows, setRows] = useState([]);
  // Popup
  let [popupHistoryCL, setPopupHistoryCL] = useState(new classPopup());
  const [idSelect, setIdSelect] = useState(null);
  const [dataSelected, setDataSelected] = useState(null);
  const [listOffice, setListOffice] = useState(
    !isAdmin ? [currentSelectOffice] : []
  );
  // In-Popup
  const [linkDriver,setLinkDriver] = useState("")
  const [linkDriverAll,setLinkDriverAll] = useState("")

  function removeSelectMachineByKey(key) {
    return listSelectMachine.filter(item => !item.hasOwnProperty(key));
  }
  
  useEffect(() => {
    let senderValue = "";
    if (
      headOfficeRole === RoleHeadOffice.OPERATION_MANAGE_UNIT ||
      headOfficeRole === RoleHeadOffice.INFO_SYSTEM_G
    ) {
      senderValue = `${displayName}`;
    } else {
      senderValue = `${selectedFactoryName}ー${displayName}`;
    }
    setSender({ ...sender, value: senderValue });
  }, [selectedFactoryName, displayName, headOfficeRole]);

  // Change data
  useEffect(() => {
    if (!initPage) {
      FLAG_CHANGE_DATA = true;
    }
  }, [hdnChecklistID, txtTitle, txtNameEl]);

  // Init
  useEffect(() => {
    if (isAdmin) {
      setListOffice(
        factories.map((item) => ({
          key: item.siteOfficeMasterCode,
          value: item.siteOfficeMasterName,
        }))
      );
      // if (!id) {
      //   setSelectedOffice(factories.map((i) => i.siteOfficeMasterCode));
      // }
    } else {
      setListOffice([currentSelectOffice]);
      if (!id) {
        setSelectedOffice([currentSelectOffice.key]);
      }
    }
  }, [factories, isAdmin, selectedFactory, id]);

  const getListCate = () => {
    VideoApi.getListCate().then((res) => {
      const dataOps = res.data.map((item) => ({
        key: item.id,
        value: item.category,
      }));
      setListAllCategory(dataOps);
    });
  };
  // Init
  useEffect(() => {
    getListCate();
  }, []);

  const getListtag = () => {
    VideoApi.getListTag().then((res) => {
      const dataOps = res.data;
      setListAllTag(dataOps);
    });
  };
  // Init
  useEffect(() => {
    getListtag();
  }, []);

  const getLinkDriver = () => {
    const isFullOffcie = selectedOffice.includes(VALUE_FULL);
    if((isFullOffcie && linkDriverAll) || (!isFullOffcie && linkDriver)){
      return;
    }
    kbn.getGgDriverLink({
      siteOfficeMasterCode: isFullOffcie ? VALUE_FULL :  selectedFactory
    }).then((res) => {
      if(isFullOffcie){
        setLinkDriverAll(res.data)
      }
      else{
        setLinkDriver(res.data)
      }
    });
  };
  // Init
  useEffect(() => {
    getLinkDriver();
  }, [selectedOffice]);

  async function fetchWithLimit(rows, limit = 5) {
    const result = [];
    let i = 0;

    while (i < rows.length) {
      const batch = rows.slice(i, i + limit);
      const batchResult = await Promise.all(
        batch.map((row) =>
          VideoApi.getAllItemByMachine({
            machineCode: row.singleValue,
          }).then((res) => ({
            ...row,
            listItem: res.data.map((item) => ({
              key: item.id,
              value: item.checkItemName,
            })),
          }))
        )
      );
      result.push(...batchResult);
      i += limit;
    }

    return result;
  }
  const showDetail = async (data) => {
    settxtTitle({ ...txtTitle, value: data.title });
    //settxtType({ ...txtType, value: data.type });
    setSender({ ...sender, value: data.displayName || data.updateId });
    setTxtDescription({ ...txtDescription, value: data.videoExplanation });
    setVideoUrl({ ...videoUrl, value: data.videoUrl });
    setTags(data.tagLists);
    if (data.categoryID !== null && data.categoryID !== undefined) {
      setListCate({
        ...listCate,
        value: data.categoryID,
        label: data.categoryName,
      });
    }

    const resultItem = Object.values(
      data.manualVideoItemDTOs.reduce((acc, curr) => {
        const key = curr.machineForSiteOfficeCode;
        const label = curr.machineForSiteOfficeName;

        if (!acc[key]) {
          acc[key] = {
            singleValue: key,
            multipleValues: [],
            singleLabel: label,
            machineCode: curr.siteOfficeMasterCode,
          };
        }

        if (curr.checkItemID) {
          acc[key].multipleValues.push(curr.checkItemID);
        }

        return acc;
      }, {})
    );
    setSelectedOffice(data.videoOfficeDTOs.map((i) => i.siteOfficeMasterCode));

    const rowsFinal = await fetchWithLimit(resultItem);
    setRows(rowsFinal);
    setListSelectMachine(rowsFinal.map(i => ({[i.singleValue]:{}})))
  };

  const getDetailData = async () => {
    try {
      openLoadingSpinner();
      const res = await VideoApi.getManualVideoById(id);
      await showDetail(res.data);
    } catch (error) {
      handleCatchError(error);
    } finally {
      closeLoadingSpinner();
    }
  };
  useEffect(() => {
    if (id) {
      getDetailData();
    }
  }, [id]);



  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    let callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };

  const onCloseSearchHistory = () => {
    setPopupHistoryCL({ ...popupHistoryCL, show: false });
    setDataSelected(null);
    setIdSelect(null);
  };

  const handleSaveData = async () => {
    try {
      openLoadingSpinner();
      const body = {
        title: txtTitle.value,
        videoExplanation: txtDescription.value,
        categoryID: listCate.isNew ? null : listCate.value,
        categoryName: listCate.label,
        videoUrl: videoUrl.value,
        tagEntityDTOs: tags,
        videoOfficeDTOs: selectedOffice.map((item) => ({
          siteOfficeMasterCode: item,
        })),

        manualVideoItemDTOs: rows
          .filter((i) => i.multipleValues.length > 0 || i.singleValue)
          .flatMap((item) => {
            if (item.multipleValues.length > 0) {
              return item.multipleValues.map((value) => ({
                machineForSiteOfficeCode: item.singleValue,
                checkItemID: value,
              }));
            } else {
              return [
                {
                  machineForSiteOfficeCode: item.singleValue,
                  checkItemID: null,
                },
              ];
            }
          }),
      };
      if (id) {
        body.id = id;
      }
      id
        ? await VideoApi.updateManualVideo(body)
        : await VideoApi.createManualVideo(body);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, async () => {
        backToSearch();
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      closeLoadingSpinner();
    }
  };
  function confirmSaveData() {
    setIsDirty(true);
    if (validateSave()) {
      Modal.confirm({
        centered: true,
        title: lang.CONFIRM,
        content: id ? COMMON_CONSTANT.BOM_C009 : COMMON_CONSTANT.BOM_C008,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        icon: <QuestionCircleOutlined />,
        onOk: () => {
          handleSaveData();
        },
        onCancel: () => {},
      });
    }
  }

  function validateSave() {
    let flagError = false;
    let titleObj = { ...txtTitle };
    let urlObj = { ...videoUrl };
    const rowCheck = [...rows];
    rowCheck.forEach((row) => {
      if (row.multipleValues.length === 0 && !row.singleValue) return;
      if (!row.singleValue) {
        row.singleError = true;
      } else {
        row.singleError = false;
      }
    });
    if (rowCheck.some((i) => i.multipleError || i.singleError)) {
      flagError = true;
    }

    if (!String(urlObj.value).trim()) {
      flagError = true;
      urlObj.error = true;
      urlRef.current.focus();
    } else {
      urlObj.error = false;
    }
    if (!String(txtTitle.value).trim()) {
      flagError = true;
      titleObj.error = true;
      titleRef.current.focus();
    } else {
      titleObj.error = false;
    }
    settxtTitle(titleObj);
    setVideoUrl(urlObj);
    return !flagError;
  }

  function backToSearch() {
    history.push("/VideoManagement");
  }

  function cancelSaveData() {
    if (!FLAG_CHANGE_DATA) {
      // No update
      backToSearch();
    } else {
      // Updated
      FLAG_CHANGE_DATA = false;
      showConfirmMessage(
        COMMON_CONSTANT.BOM_C018,
        function () {
          backToSearch();
        },
        function () {
          FLAG_CHANGE_DATA = true;
        }
      );
    }
  }
  // add an empty row at the end
  const handleAddRow = () => {
    FLAG_CHANGE_DATA = true;
    const key = new Date().getTime().toString();
    setRows((prev) => [
      ...prev,
      {
        singleValue: null,
        multipleValues: [],
        key,
      },
    ]);
  };
  // update the row at a given index
  const handleSingleSelectChange = async (
    index,
    { value, label, machineCode }
  ) => {
    FLAG_CHANGE_DATA = true;
    try {
      if (value === "" && label === "") {
        setRows((prev) =>
          prev.map((row, i) =>
            i === index
              ? {
                  ...row,
                  singleValue: value,
                  multipleValues: [],
                  listItem: [],
                  singleLabel: label,
                }
              : row
          )
        );
      } else if (!value && label) {
        setRows((prev) =>
          prev.map((row, i) =>
            i === index
              ? {
                  ...row,

                  singleLabel: label,
                }
              : row
          )
        );
      } else {
        const res = await VideoApi.getAllItemByMachine({
          machineCode: value,
        });
        const listItem = res.data.map((item) => ({
          key: item.id,
          value: item.checkItemName,
        }));
        setRows((prev) =>
          prev.map((row, i) =>
            i === index
              ? {
                  ...row,
                  singleValue: value,
                  multipleValues: [],
                  listItem,
                  singleLabel: label,
                  machineCode,
                }
              : row
          )
        );
        if (!selectedOffice.includes(machineCode) && !selectedOffice.includes(VALUE_FULL)) {
          setSelectedOffice([...selectedOffice, machineCode]);
        }
      }
    } catch (error) {
      handleCatchError(error);
    }
  };
  const handleMultipleSelectChange = (index, value) => {
    FLAG_CHANGE_DATA = true;
    setRows((prev) =>
      prev.map((row, i) =>
        i === index ? { ...row, multipleValues: value } : row
      )
    );
  };
  // delete the row at a given index
  const handleDeleteRow = (indexToDelete) => {
    FLAG_CHANGE_DATA = true;
    setRows((prev) => prev.filter((_, i) => i !== indexToDelete));
  };

  const handleChangeOffice = (values, options) => {
    FLAG_CHANGE_DATA = true;
    let finalValue = values;
    if (values.includes(VALUE_FULL) && values[values.length - 1] == VALUE_FULL) {
      finalValue = [VALUE_FULL];
    }
    else if(values.includes(VALUE_FULL) && values.length != 1){
      finalValue = values.filter(i => i != VALUE_FULL)
    }
    else if (values.includes(null)) {
      finalValue = [];
    }
    setSelectedOffice(finalValue);
    if(!finalValue.includes(VALUE_FULL)){
      const finalRows = rows.filter((row) => values.includes(row.machineCode));
      const listNewMachineCode = rows.filter((row) => values.includes(row.machineCode)).map(i => i.singleValue)
      const filtered = listSelectMachine.filter(item => {
        const key = Object.keys(item)[0]; 
        return listNewMachineCode.includes(Number(key)); 
      });
      setListSelectMachine(filtered)
      
    setRows(finalRows);
    }
    else{
      setRows([])
    }
  };

  // CLICK DRIVER
  const clickButonDriver = () => {
    Modal.confirm({
      title: lang.CONFIRM,
      content: (
        <>
          <span>
            Google Driveに移動します。動画をGoogle
            Driveのフォルダへ格納後、アップロードした動画のリンクをコピーし、運転管理システムの動画リンク欄に張り付けてください。
          </span>
          <br />
          <span>
            注意：Google
            Drive操作時は、ご自身のSHIEVアカウントでログインしていることを再度ご確認ください。
          </span>
        </>
      ),
      okText: lang.OK,
      width: 500,
      cancelText: lang.CANCEL,
      icon: <QuestionCircleOutlined />,

      onOk: () => {
        window.open((selectedOffice.includes(VALUE_FULL) ? linkDriverAll : linkDriver) || "https://drive.google.com", "_blank");
      },
      centered: true,
    });
  };

  const affterSelectCateInstruction = ({key}) => {
   if(key == CATEGORY_INSTRUCTION){
    setSelectedOffice([VALUE_FULL])
    setRows([])
   }
  }
  return (
    <>
      <div style={{ background: "#fff" }} className="des-content">
        <Loading show={showLoading}></Loading>
        <TitlePage name={id ? "詳細の編集・更新" : "動画をアップロード"} />

        <GroupItem center>
          <div className="title-page d-block center mt0 mb0">
            <h1 className="bold white-space">
              {id ? "詳細の編集・更新" : "動画をアップロード"}
            </h1>
          </div>
          <div className="mt15"></div>
          <BreakLine />
          <RowInput
            name={<span style={{ color: "red" }}>{lang.TITLE}</span>}
            isVideo
            box
          >
            <Input
              ref={titleRef}
              className={txtTitle.error ? STYLE.BORDER_RED : ""}
              value={txtTitle.value}
              onChange={(v) => {
                if (String(v.target.value).length > NORMAL_TEXT_LENGTH) {
                  return;
                }
                FLAG_CHANGE_DATA = true;
                settxtTitle({
                  ...txtTitle,
                  value: v.target.value,
                });
              }}
            />
          </RowInput>
          <BreakLine />

          <RowInput name={"動画説明"} box>
            <TextArea
              value={txtDescription.value}
              onChange={(v) => {
                FLAG_CHANGE_DATA = true;
                if (String(v.target.value).length > LONG_TEXT_LENGTH) {
                  return;
                }
                setTxtDescription({
                  ...txtDescription,
                  value: v.target.value,
                });
              }}
              rows={3}
            />
          </RowInput>
          <BreakLine />

          <RowInput name={"作成者"} box>
            <Input disabled value={displayName} />
          </RowInput>
          <BreakLine />

          <RowInput name={"タグ"} box>
            <TagVideoSelect
              className={"w100"}
              tags={tags}
              setTags={(value) => {
                setTags(value);
                FLAG_CHANGE_DATA = true;
              }}
              listAll={listAllTag}
            />
          </RowInput>
          <BreakLine />
          <RowInput name={"事業所"} box>
            {!isAdmin ? (
              <Select
                tagRender={(props) => <FullTextTag {...props} />}
                dropdownClassName="custom-select-hover"
                showSearch
                disabled={!isAdmin || listCate.value == CATEGORY_INSTRUCTION}
                showArrow
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                value={selectedOffice}
                onChange={handleChangeOffice}
                optionFilterProp="label"
                filterOption={(input, option) => {
                  const label = option && option.label ? option.label : "";
                  return label.toLowerCase().includes(input.toLowerCase());
                }}
                options={listOffice.map((loc) => ({
                  label: loc.value,
                  value: loc.key,
                }))}
              />
            ) : (
              <SelectWithTagAll
                disabled={listCate.value == CATEGORY_INSTRUCTION}
                textFull={"共通"}
                valueFull={VALUE_FULL}
                checkFull={selectedOffice.length === listOffice.length}
                // valueObj={}
                value={selectedOffice}
                listSelect={listOffice.map((loc) => ({
                  key: loc.key,
                  value: loc.value,
                  label: loc.value,
                }))}
                handleChange={handleChangeOffice}
              />
            )}
          </RowInput>
          <BreakLine />
          {/* <RowInput name={"プレイリスト"} box>
          <TagLikeSingleSelect />
        </RowInput> */}
          <BreakLine />

          <RowInput name={"カテゴリー"} box>
            <TagLikeSingleSelect
              callback={affterSelectCateInstruction}
              listOption={listAllCategory}
              value={
                listCate.value
                  ? [
                      {
                        key: listCate.value,
                        value: listCate.label,
                        isNew: listCate.isNew,
                      },
                    ]
                  : []
              }
              setSelected={(selects) => {
                FLAG_CHANGE_DATA = true;
                const emptySelect = {
                  key: "",
                  value: "",
                  isNew: false,
                };
                const select =
                  Array.isArray(selects) && selects.length > 0
                    ? selects[0]
                    : emptySelect;
                const value = select.key;
                const label = select.value;
                const isNew = select.isNew;
                setListCate({
                  ...listCate,
                  value,
                  label,
                  isNew,
                });
              }}
            />
          </RowInput>
          <BreakLine />
          <RowInput name={"動画アップロード"} box>
            <div onClick={clickButonDriver}>
              {" "}
              <Button
                disabled={isStaff && id}
                className="buttonPC button--info wAuto"
              >
                Google Drive開く
              </Button>
            </div>
          </RowInput>
          <BreakLine />
          <RowInput name={<span style={{ color: "red" }}>動画リンク</span>} box>
            <div>
              <Input
                disabled={id && isStaff}
                className={videoUrl.error ? STYLE.BORDER_RED : ""}
                ref={urlRef}
                value={videoUrl.value}
                onChange={(e) => {
                  FLAG_CHANGE_DATA = true;
                  if (String(e.target.value).length > LONG_TEXT_LENGTH) {
                    return;
                  }
                  setVideoUrl({ ...videoUrl, value: e.target.value });
                }}
              />
              <div
                style={{
                  color: "red",
                }}
                className="mt10 "
              >
                *Google Drive 動画リンクを貼り付けてください。
              </div>
            </div>
          </RowInput>
          <BreakLine />

          <div>
            <RowInput name={"機器名"} box>
              {rows.length > 0 && (
                <Row className="mb5 bold" gutter={16}>
                  <Col span={10}>機器名称</Col>
                  <Col span={10}>点検項目名称</Col>
                </Row>
              )}
              {rows.map((row, index) => (
                <Row
                  gutter={16}
                  key={index}
                  style={{ marginTop: index > 0 ? 20 : 0 }}
                >
                  <Col span={10}>
                    <div className="wrap-row-dynamic">
                      <SearchMachineVideo
                       listSelectMachine={listSelectMachine}
                        listOffice={
                          selectedOffice.includes(VALUE_FULL)  ? factories.map(i => i.siteOfficeMasterCode) :
                          selectedOffice.length === 0
                            ? [selectedFactory]
                            : selectedOffice
                        }
                        clicksaved={isDirty}
                        setShowLoading={setShowLoading}
                        value={row.singleLabel}
                        onSubmit={(value) => {
                          const selected = Object.values(value)[0];
                          setListSelectMachine([...listSelectMachine,value])
                          handleSingleSelectChange(index, {
                            value: selected.machineForSiteOfficeCode,
                            label: selected.machineForSiteOfficeName,
                            machineCode: selected.siteOfficeMasterCode,
                          });
                        }}
                        // selectedMachine={row}
                        disabled={row.singleValue}
                        className={
                          !row.singleValue &&
                          isDirty &&
                          row.multipleValues.length > 0
                            ? STYLE.BORDER_RED
                            : ""
                        }
                        onChange={(e) => {
                          handleSingleSelectChange(index, {
                            value: "",
                            label: e.target.value,
                          });
                        }}
                      />
                      <div className="wrap-col-delete" style={{ width: 30 }}>
                        <div
                          onClick={() =>{
                            handleSingleSelectChange(index, {
                              value: "",
                              label: "",
                            })
                            setListSelectMachine(removeSelectMachineByKey(row.singleValue))
                          }
                          }
                          className="buttonClearText"
                        >
                          <span className="buttonClearText-icon">x</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col span={10}>
                    <Select
                      tagRender={(props) => <FullTextTag {...props} />}
                      dropdownClassName="custom-select-hover"
                      showSearch
                      showArrow
                      className={row.multipleError ? STYLE.BORDER_RED : ""}
                      mode="multiple"
                      placeholder="点検項目"
                      value={row.multipleValues}
                      onChange={(value) =>
                        handleMultipleSelectChange(index, value)
                      }
                      optionFilterProp="children"
                      disabled={!row.singleValue}
                      style={{ width: "100%" }}
                      filterOption={(input, option) => {
                        const label =
                          option && option.children ? option.children : "";
                        return label
                          .toLowerCase()
                          .includes(input.toLowerCase());
                      }}
                    >
                      {(row.listItem || []).map((item) => (
                        <Option value={item.key}>{item.value}</Option>
                      ))}
                    </Select>
                  </Col>

                  <Col span={2}>
                    <Tooltip title={lang.DELETE}>
                      <Button
                        style={{
                          width: 32,
                          minWidth: 32,
                          height: 32,
                          padding: 0,
                          display: "flex",
                          color: "red",
                          alignItems: "center",
                          justifyContent: "center",
                          marginLeft: 5, // space between link and button
                        }}
                        onClick={() => {
                          handleDeleteRow(index);
                          setListSelectMachine(removeSelectMachineByKey(row.singleValue))
                          
                        }}
                      >
                        <DeleteOutlined />
                      </Button>
                    </Tooltip>
                    {/* <Button
                                
                                        icon={<DeleteOutlined />}
                                        onClick={() => handleDeleteRow(index)}
                                    /> */}
                  </Col>
                </Row>
              ))}
              <Button
                disabled={rows.length > 20 || selectedOffice.includes(VALUE_FULL)}
                onClick={handleAddRow}
                style={{
                  marginTop: rows.length > 0 ? 20 : 0,
                }}
              >
                <PlusOutlined style={{ marginRight: 5 }} />
                機器情報を追加
              </Button>
            </RowInput>
          </div>
          <BreakLine />
        </GroupItem>
      </div>
      <FooterPage>
        <>
          <Row justify="end">
            <Col>
              <Button
                className="buttonPC button--info wAuto ml15"
                onClick={() => {
                  confirmSaveData();
                }}
              >
                <SaveOutlined />
                {COMMON_CONSTANT.SAVE}
              </Button>
            </Col>
            <Col>
              <Button
                className="buttonPC button--outline --todo-- wAuto ml15"
                onClick={cancelSaveData}
              >
                <CloseCircleOutlined />
                {lang.CANCEL}
              </Button>
            </Col>
          </Row>
        </>
      </FooterPage>
    </>
  );
}

export default AddVideo;
